import React from 'react';
import './About.css';
import nap from '../../images/nap.webp'
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="containg">
          <div className="hiro-content">
            <h1 className="hero-tit">About PrimeCare Pharmacy</h1>
            <p className="hero-subtitle">
              Delivering exceptional healthcare with compassion, expertise, and innovation since 2015
            </p>
            <div className="hero-cta">
              <Link to='/ourteam'><button className="cta-button">Meet Our Team</button></Link>
              <button className="cta-button secondary">Our Services</button>
            </div>
          </div>
        </div>
        <div className="hero-overlay"></div>
      </section>

      {/* Our Story Section */}
      <section className="story-section">
        <div className="containg">
          <div className="section-header">
            <span className="section-subtitle">Our Journey</span>
            <h2 className="section-title">Our Story</h2>
            <div className="header-divider"></div>
          </div>
          
          <div className="story-content">
            <div className="story-text">
              <p>
                Founded in 2015, PrimeCare Pharmacy Center began as a small neighborhood pharmacy with a big vision: to revolutionize healthcare accessibility. 
                Today, we've grown into a trusted nationwide provider, combining traditional pharmacy values with cutting-edge digital solutions.
              </p>
              <p>
                Our evolution from a single storefront to a comprehensive online pharmacy reflects our commitment to meeting patients where they are. 
                Through every stage of growth, we've maintained our founding principle: patient care comes first.
              </p>
              <div className="stats-grid">
                <div className="stats-item">
                  <div className="stats-number">50,000+</div>
                  <div className="stats-label">Satisfied Patients</div>
                </div>
                <div className="stats-item">
                  <div className="stats-number">24/7</div>
                  <div className="stats-label">Pharmacy Support</div>
                </div>
                <div className="stats-item">
                  <div className="stats-number">100%</div>
                  <div className="stats-label">Licensed Pharmacists</div>
                </div>
              </div>
            </div>
            <div className="story-image">
              <img 
                src="https://images.unsplash.com/photo-1587854692152-cbe660dbde88?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" 
                alt="Pharmacy team working" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-card">
            <div className="mission-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 8V12L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="mission-content">
              <h2 className="section-title">Our Mission</h2>
              <p className="mission-statement">
                To empower healthier lives through accessible, personalized pharmacy care that combines clinical excellence 
                with compassionate service. We're committed to breaking down barriers in healthcare by delivering innovative 
                solutions that put patients at the center of everything we do.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">What We Stand For</span>
            <h2 className="section-title">Our Core Values</h2>
            <div className="header-divider"></div>
          </div>
          
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C13.6418 4 15.1681 4.51732 16.4381 5.41277M21 3L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="value-title">Quality Assurance</h3>
              <p className="value-description">
                We maintain rigorous quality standards, sourcing medications only from FDA-approved manufacturers and conducting regular quality checks.
              </p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="value-title">Patient Privacy</h3>
              <p className="value-description">
                Your health information is protected with bank-level encryption and strict confidentiality protocols.
              </p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="value-title">Expert Team</h3>
              <p className="value-description">
                Our pharmacists average 15+ years of experience and participate in ongoing clinical education.
              </p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 12H18L15 21L9 3L6 12H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="value-title">Community Focus</h3>
              <p className="value-description">
                We actively support local health initiatives and provide free health screenings in underserved areas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Accreditations Section */}
      <section className="accreditations-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Our Credentials</span>
            <h2 className="section-title">Accreditations & Certifications</h2>
            <div className="header-divider"></div>
            <p className="section-description">
              Our commitment to excellence is validated by these prestigious accreditations
            </p>
          </div>
          
          <div className="accreditations-grid">
            <div className="accreditation-card">
              <div className="accreditation-logo">
                <img
                  src="https://ext.same-assets.com/3505992194/3157891197.png"
                  alt="URAC Accredited"
                />
              </div>
              <div className="accreditation-content">
                <h3 className="accreditation-title">URAC Accredited</h3>
                <p>
                PrimeCare Pharmacy Center has earned URAC accreditation for Mail Service Pharmacy, demonstrating our commitment to quality care, improved processes, and better patient outcomes.
                </p>
                <a href="#" className="learn-more">Learn More →</a>
              </div>
            </div>
            
            <div className="accreditation-card">
              <div className="accreditation-logo">
                <img
                  src={nap}
                  alt="NABP Accredited"
                />
              </div>
              <div className="accreditation-content">
                <h3 className="accreditation-title">NABP Verified</h3>
                <p>
                  Our Digital Pharmacy is accredited by the National Association of Boards of Pharmacy (NABP), meeting the highest standards for online pharmacy practices and patient safety.
                </p>
                <a href="#" className="learn-more">Learn More →</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Experience the PrimeCare Pharmacy Difference?</h2>
            <p className="cta-text">
              Join thousands of satisfied patients who trust us with their healthcare needs
            </p>
            <div className="cta-buttons">
              <Link to='/prescription'><button className="cta-button primary">Transfer Your Prescription</button></Link>
              <button className="cta-button secondary">
                {/*<a href="https://wa.me/">Contact Our Pharmacists</a>*/}
                Contact Our Pharmacists
                </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;